export default __webpack_public_path__ + "static/logo3-8c372c1b8c2f2b44cea0acee89d04bfa.png";